type ConvertParamsType =
  | 'string'
  | 'number'
  | 'boolean'
  | 'array-string'
  | 'array-number';

type ConvertParams<T> = Partial<Record<keyof T, ConvertParamsType>>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function convertParams<T extends Record<string, any>>(
  params: ConvertParams<T>,
) {
  const query = new URLSearchParams(window.location.search);

  let data = {} as T;

  for (const key in params) {
    if (query.has(key)) {
      const value = query.get(key);

      if (params[key] === 'number') {
        data = { ...data, [key]: Number(value) };
      }
      if (params[key] === 'string') {
        data = { ...data, [key]: value };
      }
      if (params[key] === 'boolean') {
        data = {
          ...data,
          [key]:
            value || value?.toString() === 'false'
              ? Boolean(JSON.parse(value))
              : undefined,
        };
      }
      if (params[key] === 'array-string') {
        data = {
          ...data,
          [key]: value ? value.split(',') : undefined,
        };
      }
      if (params[key] === 'array-number') {
        data = {
          ...data,
          [key]: value
            ? value.split(',').map((string) => Number(string))
            : undefined,
        };
      }
    }
  }

  return data;
}

export default convertParams;
